import { PaymentObject } from "./types";

export const FORM_ID = "payment";

/** Debounce (ms) for the principal auto-calculation, so it doesn't recompute on every keystroke. */
export const DEBOUNCE_DELAY_MS = 300;

/** Header eyebrow + primary action copy, shared by desktop and mobile. */
export const PANEL_EYEBROW = "Log payment";
export const ACTION_LABEL = "Save";

/** Title shown for the From Account bottom sheet on compact screens. */
export const FROM_ACCOUNT_SHEET_TITLE = "Select account";

export const DEFAULT_PAYMENT: PaymentObject = {
  paymentDate: new Date(),
  amount: "",
  principalAmount: "",
  fromAccount: null,
  note: "",
  setPrincipalManually: false,
};
